<template>
  <el-dialog :visible.sync="visible" title="添加宿舍学生" :close-on-click-modal="false" append-to-body :close-on-press-escape="false">
    <el-form :model="dataForm"  ref="dataForm" :inline="true" >
      <el-form-item prop="classId">
        <el-select v-model="classId" @keyup.enter.native="init()" placeholder="班级" clearable >
          <el-option
                  v-for="myClass in classList"
                  :key="myClass.id"
                  :label="myClass.className"
                  :value="myClass.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item >
        <el-input v-model="studentName" type="text" placeholder="学生姓名" clearable/>
      </el-form-item>
      <el-form-item>
        <el-button @click="query()">{{ $t('query') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle"
              style="width: 100%;">
      <el-table-column type="index" label="序号" header-align="center" align="center" width="50"></el-table-column>
      <el-table-column prop="studentName" label="性名" header-align="center" align="center"></el-table-column>
      <el-table-column prop="studentSex" label="性别" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.studentSex === sexual.MAN">男</el-tag>
          <el-tag v-else-if="scope.row.studentSex === sexual.WOMAN">女</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="studentNum" label="学号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="className" label="班级" header-align="center" align="center"></el-table-column>
      <el-table-column prop="setNum" label="座号" header-align="center" align="center"></el-table-column>
      <el-table-column  header-align="center" align="center" >
        <template slot-scope="scope" >
          <el-button v-if="isInArray(scope.row)" size="mini" @click="addCheckedStudents(scope.row)">选中</el-button>
          <el-button v-else=""  type="danger" size="mini" @click="removeCheckedStudents(scope.row)">移除</el-button>
        </template></el-table-column>
    </el-table>
    <el-pagination
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="limit"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="pageSizeChangeHandle"
            @current-change="pageCurrentChangeHandle">
    </el-pagination>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { sexual } from '@/constant'
import mixinViewModule from '@/mixins/view-module'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/student/student/page',
        getDataListIsPage: true,
        deleteURL: '/student/student',
        deleteIsBatch: true,
        createdIsNeed: false,
        activatedIsNeed: false
      },
      sexual,
      studentList: [],
      classList: [],
      checkedStudentList: [],
      checkedStudentsNameList: [],
      visible: false,
      classId: '',
      studentName: '',
      dataForm: {
        studentId: '',
        studentName: '',
        classId: '',
        className: '',
        dormitoryId: '',
        dormitoryName: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  mounted () {
    // this.getAssociationTeacher().
    this.init()
  },
  methods: {
    /* init () {
      this.visible = true
      this.$nextTick(() => {
        this.query()
        this.getClubStudent()
        this.getClassList()
      })
    }, */
    init (studentList, studentNameList, classId) {
      this.visible = true
      this.getClassList()
      if (studentList.length === 0) {
        this.checkedStudentList = []
        this.checkedStudentsNameList = []
      }
      if (this.checkedStudentList.length === 0) {
        for (let i = 0; studentList.length > i; i++) {
          this.checkedStudentList.push(studentList[i])
        }
        for (let i = 0; studentNameList.length > i; i++) {
          this.checkedStudentsNameList.push(studentNameList[i])
        }
      }
      console.log(this.checkedStudentList)
      this.query()
    },
    query () {
      console.log(this.classId)
      const url = '/student/student/page'
      this.dataListLoading = true
      this.$http.get(
        url,
        {
          params: {
            order: this.order,
            orderField: this.orderField,
            page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
            limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
            classId: this.classId,
            studentName: this.studentName
          }
        }
      ).then(({ data: res }) => {
        this.dataListLoading = false
        if (res.code !== 0) {
          this.dataList = []
          this.total = 0
          return this.$message.error(res.msg)
        }
        this.dataList = this.mixinViewModuleOptions.getDataListIsPage ? res.data.list : res.data
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? res.data.total : 0
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    getClassList () {
      this.$http.get('/classmanage/classmanage/getList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.classList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    addCheckedStudents (row) {
      this.checkedStudentList.push(row.id)
      console.log(this.checkedStudentList)
      this.checkedStudentsNameList.push(row.studentName)
      this.$emit('checkedStudents', [this.checkedStudentList, this.checkedStudentsNameList])
    },
    removeCheckedStudents (row) {
      for (let i = 0; i < this.checkedStudentList.length; i++) {
        if (this.checkedStudentList[i] === row.id) {
          this.checkedStudentList.splice(i, 1)
        }
      }
      for (let i = 0; i < this.checkedStudentsNameList.length; i++) {
        if (this.checkedStudentsNameList[i] === row.studentName) {
          this.checkedStudentsNameList.splice(i, 1)
        }
      }
      console.log(this.checkedStudentList)
      this.$emit('checkedStudents', [this.checkedStudentList, this.checkedStudentsNameList])
    },
    isInArray (row) {
      for (var i = 0; i < this.dataList.length; i++) {
        for (var j = 0; j < this.checkedStudentList.length; j++) {
          if (row.id === this.checkedStudentList[j]) {
            return false
          }
        }
      }
      return true
    }
  }
}
</script>

<style>
  element.style {
    /* margin-left: 90%; */
    margin-bottom: 20px
  }
</style>
